import { percent } from "../format";

export function ProgressBar({ done, total, label }: { done: number; total: number; label: string }) {
  return (
    <div className="progress-line" role="progressbar" aria-label={label} aria-valuemin={0} aria-valuemax={total} aria-valuenow={Math.min(done, total)}>
      <i style={{ width: `${percent(done, total)}%` }} />
    </div>
  );
}
